import {ComponentStore} from "@ngrx/component-store";
import {Injectable} from "@angular/core";
import {Observable, switchMap} from "rxjs";
import {SavedReportComponentObject} from "../../../../shared/classes/saved-report-component-object";
import {SavedReportsService} from "../../../../shared/services/saved-reports.service";
import {filter, tap} from "rxjs/operators";
import {Serializer, SerializerResponse} from "../../../../shared/interfaces/serializer";
import {SavedReport} from "../../../../shared/interfaces/saved-reports";

@Injectable()
export class ReportTableRowStore extends ComponentStore<any> {

  public load: (report: SavedReportComponentObject) => Observable<void> = this.effect((params$ : Observable<SavedReportComponentObject>) => params$.pipe(
    filter((report: SavedReportComponentObject) => !report.parameters$.value),
    switchMap((report: SavedReportComponentObject) => this._reportService.getSavedReport(report.payload.id).pipe(
      tap((report_loaded: SerializerResponse<Serializer<SavedReport>>) => {
        report.setParameters(report_loaded.data.attributes.parameters);
      })
    )),
  ));

  constructor(
    private readonly _reportService: SavedReportsService
  ) {
    super({});
  }
}
